"use strict";

class Dan_ToggleSection {
	/** @var {HTMLElement} */
	#$section;

	/** @var {NodeListOf<HTMLInputElement>} */
	#$controls;


	constructor($section) {
		this.#$section = $section;
	}

	initialize() {
		// Initialize elements.
		this.#$controls = document.querySelectorAll(".dan-toggle-section-control[data-section='" + this.#$section.id + "']");

		// Add handler to controls.
		for (const $control of this.#$controls) {
			$control.addEventListener("change", this.onControlChanged.bind(this, $control));
		}

		// Initialize section by the first control.
		if (this.#$controls.length > 0) {
			this.onControlChanged(this.#$controls[0]);
		}
	}

	onControlChanged($control) {
		if ($control.checked && !this.#$section.classList.contains("-expanded")) {
			this.show();
		} else if (!$control.checked && this.#$section.classList.contains("-expanded")) {
			this.hide();
		}
	}

	show() {
		// Set section height.
		this.#$section.classList.add("-expanded");
		this.#$section.style.height = this.#$section.scrollHeight + 'px';

		setTimeout(() => {
			this.#$section.style.height = 'auto';
		}, 500);

		// Set controls state.
		for (const $control of this.#$controls) {
			$control.checked = true;
		}
	}

	hide() {
		// Set section height.
		this.#$section.classList.remove("-expanded");
		this.#$section.style.height = this.#$section.scrollHeight + 'px';

		setTimeout(() => {
			this.#$section.style.height = '0px';
		}, 25);
	}
}
